import vue from '@/main'
import parms from '@/public/parms.js'
export default {
    //如果接口需要登录才能调  就需要这个方法
	requestPost(post, updata, method,header) {
		return new Promise((resolve,reject)=>{
			// 调下面普通请求之前验证一哈是否需要登录
			var tokenstr = vue.cache.get('token');
			this.checklogin().then(()=>{
				//已登录
				header = {token:tokenstr.token,logintype:2};
				this.request(post, updata, method , header).then(ass=>{
					resolve(ass);
				}).catch(aser=>{
					reject(aser);
				});
			}).catch(()=>{
				//未登录
				vue.$confirm('登录以获取更好的服务！', '授权须知', {
					confirmButtonText: '去登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					vue.$router.replace('login');
				}).catch(()=>{
					vue.$message.error('已拒绝登录');
				});
			})

		})
	},
	//普通请求不需要验证登录的请求
	request(post, data, method='get',header={}){
		return new Promise((resolve,reject)=>{
			if (post == '') {
				vue.$message.error('空请求');
				return reject();
			}
			var axiosconfig = {
				method: method,
				url: post,
				headers:header,
				responseType:'json',
				transformResponse: [function (data) {
          return JSON.parse(JSON.parse(data));
				}],
			};
			if(method == 'get'){
				axiosconfig.params = data;
			}else if(method == 'post'){
				axiosconfig.data = data;
			}
			vue.$axios(axiosconfig).then(function (res) {
				if (res.data.status == 200 || res.data.status == 1) {
					return resolve(res.data);
				} else {
          if(res.data.status == 4001){
            vue.$router.replace('login');
          }else{
            vue.$message.error(res.data.msg);
          }
          return reject();
				}
			}).catch((err)=>{
        vue.$message.error(err.msg);
				return reject();
			});
		})
	},
	//检查登录
	checklogin(){
		return new Promise((resolve,reject)=>{
			var login_status = vue.cache.get('token');
			if(!login_status){
				reject(false);
			}
			if((login_status.expire*1000)<=Date.now()){
				reject(false);
			}
			resolve(true);
		})
	},
	getUrlCode(name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) ||[, ''])[1].replace(/\+/g, '%20')) || null
	},
	/**
	 * 处理富文本里的图片宽度自适应
	 * 1.去掉img标签里的style、width、height属性
	 * 2.img标签添加style属性：max-width:100%;height:auto
	 * 3.修改所有style里的width属性为max-width:100%
	 * 4.去掉<br/>标签
	 * @param html
	 * @returns {void|string|*}
	 */
	formatRichText(html) {
		if(!html){
			return html;
		}
		let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
			match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
			match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
			match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
			return match;
		});
		newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
			match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
			return match;
		});
		newContent = newContent.replace(/<br[^>]*\/>/gi, '');
		newContent = newContent.replace(/\<img/gi,'<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
		// a 为富文本的字符串内容，为了测试，只写了img标签
		var b = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;// img 标签取src里面内容的正则
		var s = newContent.match(b);// 取到所有img标签 放到数组 s里面
		if(s.length){
			for (var i = 0; i < s.length; i++) {
				var srcImg = s[i].replace(b, '$1');//取src面的内容
				if (srcImg.slice(0, 4) == 'http' || srcImg.slice(0, 5) == 'https') {
				//若src前4位置或者前5位是http、https则不做任何修改
					console.log('不做任何修改');
				} else {
				//修改富文本字符串内容 img标签src 相对路径改为绝对路径
					newContent = newContent.replace(new RegExp(srcImg, 'g'), parms.hosts + srcImg);
				}
			}
		}
		return newContent;
	}

}



// WEBPACK FOOTER //
// ./src/public/requests.js